import React from "react";

import AppErrorFallback from "#/components/AppErrorFallback";
import DevErrorFallback from "#/components/DevErrorFallback";
import env from "#/env";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error);
    console.error(info);

    // Store error details for rendering
    this.setState({
      error,
      errorInfo: info,
    });

    // logErrorToMyService(
    //   error,
    //   // Example "componentStack":
    //   //   in ComponentThatThrows (created by App)
    //   //   in ErrorBoundary (created by App)
    //   //   in div (created by App)
    //   //   in App
    //   info.componentStack,
    //   // Warning: `captureOwnerStack` is not available in production.
    //   React.captureOwnerStack(),
    // );
  }

  render() {
    if (this.state.hasError) {
      // In development, show detailed error information
      if (env.isDevelopment) {
        const { error, errorInfo } = this.state;
        return <DevErrorFallback error={error} errorInfo={errorInfo} />;
      }

      // In production, show custom fallback UI
      return this.props.fallback ? <AppErrorFallback /> : null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
